import { render, staticRenderFns } from "./settlement-promoter.vue?vue&type=template&id=48140ee0&"
import script from "./settlement-promoter.vue?vue&type=script&lang=js&"
export * from "./settlement-promoter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports